import { useEffect } from 'react';

interface TermsModalProps {
  onClose: () => void;
}

interface Section {
  title: string;
  content: string;
  items?: string[];
  subsections?: { subtitle: string; items: string[] }[];
}

const sections: Section[] = [
  {
    title: '제1조 (목적)',
    content:
      '이 약관은 주식회사 위딘(이하 "회사")이 운영하는 온라인 쇼핑몰 WITHIN(이하 "사이트")에서 제공하는 전자상거래 관련 서비스(이하 "서비스")를 이용함에 있어 사이트와 이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.',
  },
  {
    title: '제2조 (정의)',
    content: '이 약관에서 사용하는 용어의 정의는 다음과 같습니다.',
    items: [
      '"사이트"란 회사가 재화 또는 용역(이하 "재화 등")을 이용자에게 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 운영하는 가상의 영업장을 말합니다.',
      '"이용자"란 사이트에 접속하여 이 약관에 따라 사이트가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.',
      '"회원"이란 사이트에 개인정보를 제공하여 회원등록을 한 자로서, 사이트의 정보를 지속적으로 제공받으며 사이트가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.',
      '"비회원"이란 회원에 가입하지 않고 사이트가 제공하는 서비스를 이용하는 자를 말합니다.',
    ],
  },
  {
    title: '제3조 (약관의 명시와 설명 및 개정)',
    content: '',
    items: [
      '회사는 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소, 전화번호, 전자우편주소, 사업자등록번호, 통신판매업 신고번호를 이용자가 쉽게 알 수 있도록 사이트의 초기 서비스화면에 게시합니다.',
      '회사는 이용자가 약관에 동의하기에 앞서 약관에 정하여져 있는 내용 중 청약철회, 배송책임, 환불조건 등과 같은 중요한 내용을 이용자가 이해할 수 있도록 별도의 연결화면 또는 팝업화면 등을 제공하여 이용자의 확인을 구하여야 합니다.',
      '회사는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제에 관한 법률, 전자문서 및 전자거래기본법, 전자서명법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 소비자기본법 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.',
      '회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 사이트의 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. 다만, 이용자에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지합니다.',
      '이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제 등에 관한 법률, 공정거래위원회가 정하는 전자상거래 등에서의 소비자 보호지침 및 관계법령 또는 상관례에 따릅니다.',
    ],
  },
  {
    title: '제4조 (서비스 제공 및 변경)',
    content: '회사는 다음과 같은 업무를 수행합니다.',
    items: [
      '재화 또는 용역에 대한 정보 제공 및 구매계약의 체결',
      '구매계약이 체결된 재화 또는 용역의 배송',
      '기타 회사가 정하는 업무',
    ],
  },
  {
    title: '제5조 (서비스의 중단)',
    content: '',
    items: [
      '회사는 컴퓨터 등 정보통신설비의 보수점검·교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.',
      '회사는 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단, 회사가 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.',
    ],
  },
  {
    title: '제6조 (회원가입)',
    content: '',
    items: [
      '이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.',
      '회사는 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각호에 해당하지 않는 한 회원으로 등록합니다.',
      '회원가입계약의 성립 시기는 회사의 승낙이 회원에게 도달한 시점으로 합니다.',
      '회원은 등록사항에 변경이 있는 경우, 즉시 전자우편 기타 방법으로 회사에 대하여 그 변경사항을 알려야 합니다.',
    ],
  },
  {
    title: '제7조 (회원 탈퇴 및 자격 상실 등)',
    content: '',
    items: [
      '회원은 회사에 언제든지 탈퇴를 요청할 수 있으며 회사는 즉시 회원탈퇴를 처리합니다.',
      '회원이 다음 각호의 사유에 해당하는 경우, 회사는 회원자격을 제한 및 정지시킬 수 있습니다.',
      '가입 신청 시에 허위 내용을 등록한 경우',
      '다른 사람의 사이트 이용을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우',
      '사이트를 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우',
    ],
  },
  {
    title: '제8조 (구매신청 및 개인정보 제공 동의 등)',
    content: '사이트 이용자는 사이트 상에서 다음 또는 이와 유사한 방법에 의하여 구매를 신청하며, 회사는 이용자가 구매신청을 함에 있어서 다음의 각 내용을 알기 쉽게 제공하여야 합니다.',
    items: [
      '재화 등의 검색 및 선택',
      '받는 사람의 성명, 주소, 전화번호, 전자우편주소 등의 입력',
      '약관내용, 청약철회권이 제한되는 서비스, 배송료·설치비 등의 비용부담과 관련한 내용에 대한 확인',
      '이 약관에 동의하고 위 항목을 확인하거나 거부하는 표시 (예, 마우스 클릭)',
      '재화 등의 구매신청 및 이에 관한 확인 또는 회사의 확인에 대한 동의',
      '결제방법의 선택',
    ],
  },
  {
    title: '제9조 (계약의 성립)',
    content: '',
    items: [
      '회사는 제8조와 같은 구매신청에 대하여 다음 각호에 해당하면 승낙하지 않을 수 있습니다. 다만, 미성년자와 계약을 체결하는 경우에는 법정대리인의 동의를 얻지 못하면 미성년자 본인 또는 법정대리인이 계약을 취소할 수 있다는 내용을 고지하여야 합니다.',
      '신청 내용에 허위, 기재누락, 오기가 있는 경우',
      '미성년자가 담배, 주류 등 청소년보호법에서 금지하는 재화 및 용역을 구매하는 경우',
      '기타 구매신청에 승낙하는 것이 회사 기술상 현저히 지장이 있다고 판단하는 경우',
      '회사의 승낙이 수신확인통지 형태로 이용자에게 도달한 시점에 계약이 성립한 것으로 봅니다.',
    ],
  },
  {
    title: '제10조 (지급방법)',
    content: '사이트에서 구매한 재화 또는 용역에 대한 대금지급방법은 다음 각호의 방법 중 가용한 방법으로 할 수 있습니다.',
    items: [
      '폰뱅킹, 인터넷뱅킹, 메일 뱅킹 등의 각종 계좌이체',
      '선불카드, 직불카드, 신용카드 등의 각종 카드 결제',
      '온라인 무통장입금',
      '전자화폐에 의한 결제',
      '수령 시 대금지급',
      '마일리지 등 회사가 지급한 포인트에 의한 결제',
      '회사와 계약을 맺었거나 회사가 인정한 상품권에 의한 결제',
      '기타 전자적 지급 방법에 의한 대금 지급 등',
    ],
  },
  {
    title: '제11조 (수신확인통지·구매신청 변경 및 취소)',
    content: '',
    items: [
      '회사는 이용자의 구매신청이 있는 경우 이용자에게 수신확인통지를 합니다.',
      '수신확인통지를 받은 이용자는 의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은 후 즉시 구매신청 변경 및 취소를 요청할 수 있고 회사는 배송 전에 이용자의 요청이 있는 경우에는 지체없이 그 요청에 따라 처리하여야 합니다. 다만 이미 대금을 지불한 경우에는 제15조의 청약철회 등에 관한 규정에 따릅니다.',
    ],
  },
  {
    title: '제12조 (배송)',
    content:
      '회사는 이용자와 배송방법에 관하여 별도의 약정이 없는 이상, 이용자가 청약을 한 날부터 7일 이내에 재화 등을 배송할 수 있도록 발송 등의 조치를 취합니다. 다만, 회사가 이미 재화 등의 대금의 전부 또는 일부를 받은 경우에는 대금의 전부 또는 일부를 받은 날부터 3영업일 이내에 조치를 취합니다.',
  },
  {
    title: '제13조 (환급)',
    content:
      '회사는 이용자가 구매신청한 재화 등이 품절 등의 사유로 인도 또는 제공을 할 수 없을 때에는 지체없이 그 사유를 이용자에게 통지하고 사전에 재화 등의 대금을 받은 경우에는 대금을 받은 날부터 3영업일 이내에 환급하거나 환급에 필요한 조치를 취합니다.',
  },
  {
    title: '제14조 (청약철회 등)',
    content: '',
    items: [
      '회사와 재화 등의 구매에 관한 계약을 체결한 이용자는 수신확인의 통지를 받은 날부터 7일 이내에는 청약의 철회를 할 수 있습니다.',
      '이용자는 재화 등을 배송 받은 경우 다음 각호의 1에 해당하는 경우에는 반품 및 교환을 할 수 없습니다.',
      '이용자에게 책임 있는 사유로 재화 등이 멸실 또는 훼손된 경우 (다만, 재화 등의 내용을 확인하기 위하여 포장 등을 훼손한 경우에는 청약철회를 할 수 있습니다)',
      '이용자의 사용 또는 일부 소비에 의하여 재화 등의 가치가 현저히 감소한 경우',
      '시간의 경과에 의하여 재판매가 곤란할 정도로 재화 등의 가치가 현저히 감소한 경우',
      '같은 성능을 지닌 재화 등으로 복제가 가능한 경우 그 원본인 재화 등의 포장을 훼손한 경우',
    ],
  },
  {
    title: '제15조 (청약철회 등의 효과)',
    content: '',
    items: [
      '회사는 이용자로부터 재화 등을 반환받은 경우 3영업일 이내에 이미 지급받은 재화 등의 대금을 환급합니다.',
      '회사는 위 대금을 환급함에 있어서 이용자가 신용카드 또는 전자화폐 등의 결제수단으로 재화 등의 대금을 지급한 때에는 지체없이 당해 결제수단을 제공한 사업자로 하여금 재화 등의 대금의 청구를 정지 또는 취소하도록 요청합니다.',
      '청약철회 등의 경우 공급받은 재화 등의 반환에 필요한 비용은 이용자가 부담합니다. 회사는 이용자에게 청약철회 등을 이유로 위약금 또는 손해배상을 청구하지 않습니다. 다만 재화 등의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행되어 청약철회 등을 하는 경우 재화 등의 반환에 필요한 비용은 회사가 부담합니다.',
    ],
  },
  {
    title: '제16조 (개인정보 보호)',
    content:
      '회사는 이용자의 개인정보 수집 시 서비스제공을 위하여 필요한 범위에서 최소한의 개인정보를 수집합니다. 회사는 회원가입 시 구매계약이행에 필요한 정보를 미리 수집하지 않습니다. 다만, 관련 법령상 의무이행을 위하여 구매계약 이전에 본인확인이 필요한 경우로서 최소한의 특정 개인정보를 수집하는 경우에는 그러하지 아니합니다.',
  },
  {
    title: '제17조 (회사의 의무)',
    content: '',
    items: [
      '회사는 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 재화·용역을 제공하는 데 최선을 다하여야 합니다.',
      '회사는 이용자가 안전하게 인터넷 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함)보호를 위한 보안 시스템을 갖추어야 합니다.',
      '회사가 상품이나 용역에 대하여 표시·광고의 공정화에 관한 법률 제3조 소정의 부당한 표시·광고행위를 함으로써 이용자가 손해를 입은 때에는 이를 배상할 책임을 집니다.',
    ],
  },
  {
    title: '제18조 (회원의 ID 및 비밀번호에 대한 의무)',
    content: '',
    items: [
      '제17조의 경우를 제외한 ID와 비밀번호에 관한 관리책임은 회원에게 있습니다.',
      '회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.',
      '회원이 자신의 ID 및 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 회사에 통보하고 회사의 안내가 있는 경우에는 그에 따라야 합니다.',
    ],
  },
  {
    title: '제19조 (이용자의 의무)',
    content: '이용자는 다음 행위를 하여서는 안 됩니다.',
    items: [
      '신청 또는 변경 시 허위 내용의 등록',
      '타인의 정보 도용',
      '회사에 게시된 정보의 변경',
      '회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시',
      '회사와 기타 제3자의 저작권 등 지적재산권에 대한 침해',
      '회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위',
      '외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 사이트에 공개 또는 게시하는 행위',
    ],
  },
  {
    title: '제20조 (연결사이트와 피연결사이트 간의 관계)',
    content: '',
    items: [
      '상위 사이트와 하위 사이트가 하이퍼링크(예: 하이퍼링크의 대상에는 문자, 그림 및 동화상 등이 포함됨) 방식 등으로 연결된 경우, 전자를 연결사이트(웹 사이트)라고 하고 후자를 피연결사이트(웹사이트)라고 합니다.',
      '연결사이트는 피연결사이트가 독자적으로 제공하는 재화 등에 의하여 이용자와 행하는 거래에 대해서 보증 책임을 지지 않는다는 뜻을 연결사이트의 초기화면 또는 연결되는 시점의 팝업화면으로 명시한 경우에는 그 거래에 대한 보증 책임을 지지 않습니다.',
    ],
  },
  {
    title: '제21조 (저작권의 귀속 및 이용제한)',
    content: '',
    items: [
      '회사가 작성한 저작물에 대한 저작권 기타 지적재산권은 회사에 귀속합니다.',
      '이용자는 사이트를 이용함으로써 얻은 정보 중 회사에게 지적재산권이 귀속된 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.',
    ],
  },
  {
    title: '제22조 (분쟁해결)',
    content: '',
    items: [
      '회사는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치·운영합니다.',
      '회사는 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보해 드립니다.',
      '회사와 이용자 간에 발생한 전자상거래 분쟁과 관련하여 이용자의 피해구제신청이 있는 경우에는 공정거래위원회 또는 시·도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수 있습니다.',
    ],
  },
  {
    title: '제23조 (재판권 및 준거법)',
    content:
      '회사와 이용자 간에 발생한 전자상거래 분쟁에 관한 소송은 제소 당시의 이용자의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에 제기합니다. 이 약관에 관한 준거법은 대한민국 법령으로 합니다.',
  },
];

export default function TermsModal({ onClose }: TermsModalProps) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKey);
    };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative z-10 bg-[#2C2825] border border-white/10 rounded-2xl w-full max-w-2xl max-h-[80vh] flex flex-col shadow-2xl">

        {/* Header */}
        <div className="flex items-center justify-between px-8 py-5 border-b border-white/10 flex-shrink-0">
          <h2 className="text-white text-lg font-medium tracking-wide">이용약관</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-white text-lg"></i>
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto px-8 py-6 space-y-6 text-white/60 text-sm leading-relaxed">
          <div>
            <p className="text-white/30 text-xs mb-2">시행일: 2024년 01월 01일</p>
            <p className="text-white/50 text-xs">
              주식회사 위딘(이하 &quot;회사&quot;)이 운영하는 온라인 쇼핑몰 WITHIN(이하 &quot;사이트&quot;)에서
              제공하는 전자상거래 관련 서비스를 이용하기 위해서는 본 이용약관에 동의하셔야 합니다.
              본 약관을 주의 깊게 읽어보시기 바랍니다.
            </p>
          </div>

          {sections.map((section) => (
            <div key={section.title}>
              <h3 className="text-white text-sm font-medium mb-2">{section.title}</h3>
              {section.content && (
                <p className="mb-2">{section.content}</p>
              )}
              {section.items && (
                <ul className="space-y-1.5 list-disc list-inside">
                  {section.items.map((item) => (
                    <li key={item} className="text-white/60 text-xs leading-relaxed">{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}

          <p className="text-white/30 text-xs pt-4 border-t border-white/10">
            본 약관은 2024년 01월 01일부터 적용됩니다. 주식회사 위딘 · 대표자: 전가혜
          </p>
        </div>

        {/* Footer */}
        <div className="px-8 py-5 border-t border-white/10 flex-shrink-0">
          <button
            onClick={onClose}
            className="w-full bg-[#8B7355] text-white py-3 rounded-full text-sm font-medium hover:bg-[#7A6548] transition-colors cursor-pointer whitespace-nowrap"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}
